<article class="news-card" *ngIf="news">
  <div class="news-image-wrap">
    <img [src]="img" [alt]="news.title" />
    <span class="status" [class.status--published]="news.active">
      <span></span>{{ news.active ? 'Опубликовано' : 'Черновик' }}
    </span>
  </div>

  <div class="news-body">
    <time>{{ news.date | date: 'dd.MM.yyyy, HH:mm' }}</time>
    <h2>{{ news.title }}</h2>
    <p>{{ news.text }}</p>
    <div class="news-actions">
      <button mat-stroked-button color="primary" (click)="update()">
        <mat-icon>edit</mat-icon> Редактировать
      </button>
      <button mat-button color="warn" (click)="delete()" [disabled]="deleting">
        <mat-icon>{{ deleting ? 'hourglass_empty' : 'delete_outline' }}</mat-icon>
        {{ deleting ? 'Удаляем…' : 'Удалить' }}
      </button>
    </div>
  </div>
</article>
